import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TableColumn } from '../../../dto/util/table-column';
import { FiltroDto } from '../../../dto/util/filtro-dto';
import { ExpedienteFiltroDto } from '../../../dto/expediente/expediente.filtro.dto';
import { HistoricoSicDto } from '../../../dto/expediente/historico-sic.dto';
import { ExpedienteSicDto } from '../../../dto/expediente/expediente-sic.dto';
import { ExpedienteService } from '../../../services/expediente.service';
import { UtilService } from '../../../services/util.service';

import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import { Constants } from '../../../constants/constants';
import { DescargaDocumentosComponent } from '../descarga-documentos/descarga-documentos.component';
import { ModalService } from '../../../services/util/modal.service';
import { InfoPantallaDTO } from '../../../dto/util/infoPantallaDTO';
import { Entidades } from '../../../constants/entidades.constants';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { EntidadApiResponse } from "../../../dto/entidad/entidad-response.dto";
import { EntidadService } from "../../../services/entidad.service";
@Component({
  selector: 'app-detalle-sic',
  templateUrl: './detalle-sic.component.html',
  styleUrl: './detalle-sic.component.scss',
})
export class DetalleSicComponent implements OnInit {
  private activatedRoute = inject(ActivatedRoute);

  entidadId = 2;
  entidad!: EntidadApiResponse;
  expedienteId = 0;
  usuarioCreadorId = 0;
  expedienteData: ExpedienteSicDto = {};
  historicoSic: HistoricoSicDto[] = [];
  estadoProceso: object[] = [];
  columns: TableColumn[] = [];
  tamanoPagina = 5;
  totalPaginas = 0;
  paginaActual = 1;
  showButton = true;
  isCreator = false;
  public role = '';
  tipoDocumentoUsuario = '';
  numeroIdentificacion = '';

  filtros: FiltroDto<ExpedienteFiltroDto> = {
    pagina: 1,
    tamanoPagina: 10,
    ordenarAsc: false,
    ordenarPor: 'marca_tiempo',
    filtros: {},
  };

  // Información de la pantalla y guía interactiva
  infoPantalla!: InfoPantallaDTO;

  // Multilenguaje
  tableText: any = {};
  guiaText: any = {};
  guiaSICText: any = {};

  showGuia: boolean = true;

  constructor(
    private readonly service: ExpedienteService,
    private readonly router: Router,
    private readonly utilService: UtilService,
    private readonly modalService: ModalService,
    private readonly translate: TranslateService,
    private entidadService: EntidadService
  ) {
    const userData = sessionStorage.getItem(Constants.USER_TYPE);
    if (userData) {
      const parseObject = JSON.parse(userData);
      this.role = parseObject.Nombre;
    }

    // Multilenguaje
    this.translate.stream('detalle-DNDA').forEach(text => {
      for (let key of Object.keys(text)) {
        this.tableText[key] = text[key];
      }
      this.initColumns();
    });
    combineLatest({
      guias: this.translate.stream('guias-interactivas'),
      guiaSic: this.translate.stream('guia-SIC'),
    }).subscribe(({ guias, guiaSic }) => {
      // Asignar traducciones a variables
      this.guiaText = guias;
      this.guiaSICText = guiaSic;
      this.ngOnInit();
    });
  }

  ngOnInit(): void {
    this.initColumns();
    this.cargarEntidad();
    this.expedienteId = this.activatedRoute.snapshot.params['expedienteId'];
    this.usuarioCreadorId = this.activatedRoute.snapshot.params['usuarioId'];
    this.getExpendienteDetail();
    // Se toma la información del usuario que inicia sesión
    const infoInicioSesion = JSON.parse(
      sessionStorage.getItem(Constants.USER_INFORMATION_STORAGE) ?? '{}'
    );
    this.isCreator = infoInicioSesion.idUsuario === +this.usuarioCreadorId;
    this.tipoDocumentoUsuario = infoInicioSesion.tipoDocumento;
    this.numeroIdentificacion = infoInicioSesion.identificacion;
    const isShowGuia = sessionStorage.getItem(Constants.SHOW_GUIA_DETALLE_SIC) != null ? false : this.showGuia
    // Se asigna información a InfoPantallaDTO
    this.infoPantalla = {
      tituloPantalla: this.guiaText['expediente-titulo'],
      descripcionPantalla: this.guiaSICText['descripcion-pantalla'],
      pasos: [
        {
          element: '#tour',
          popover: {
            title: this.guiaSICText['tour-titulo'],
            description: this.guiaText['tour-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: this.guiaText['usuario-titulo'],
            description: this.guiaText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: this.guiaText['alertas-titulo'],
            description: this.guiaText['alertas-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: this.guiaText['glosario-titulo'],
            description: this.guiaText['glosario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: this.guiaText['info-titulo'],
            description: this.guiaText['info-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: this.guiaSICText['encabezado-titulo'],
            description: this.guiaSICText['encabezado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: this.guiaSICText['crear-solicitud-titulo'],
            description: this.guiaSICText['crear-solicitud-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historicoBtn',
          popover: {
            title: this.guiaSICText['historico-titulo'],
            description: this.guiaSICText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: this.guiaSICText['historico-titulo'],
            description: this.guiaSICText['historico-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: this.guiaSICText['filtro-titulo'],
            description: this.guiaSICText['filtro-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#numero_proceso',
          popover: {
            title: this.guiaSICText['consecutivo'],
            description: this.guiaSICText['consecutivo-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#marca_tiempo',
          popover: {
            title: this.guiaSICText['marca-titulo'],
            description: this.guiaSICText['marca-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#usuario',
          popover: {
            title: this.guiaSICText['usuario-titulo'],
            description: this.guiaSICText['usuario-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado_proceso',
          popover: {
            title: this.guiaSICText['estado-titulo'],
            description: this.guiaSICText['estado-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#documento',
          popover: {
            title: this.guiaSICText['documento-titulo'],
            description: this.guiaSICText['documento-descripcion'],
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    };
    // Se valida que sea el primer inicio de sesión para ejecutar la guía interactiva
    if (infoInicioSesion.primerInicioSesion && isShowGuia) {
      this.utilService.changeInfoPantalla(this.infoPantalla);
      this.utilService.iniciarGuiaInteractiva();
      sessionStorage.setItem(Constants.SHOW_GUIA_DETALLE_SIC, 'false')
    } else {
      this.utilService.changeInfoPantalla(this.infoPantalla);
    }
    this.utilService.watch().subscribe(val => {
      this.showButton = val;
    });
    this.utilService.setIdEntidad(this.entidadId);
  }

  cargarEntidad(): void {
    this.entidadService.obtenerEntidadPorId(this.entidadId).subscribe({
      next: (data) => {
        this.entidad = data;
      },
      error: (error) => console.error('Error al obtener la entidad:', error),
    });
  }

  getExpendienteDetail() {
    this.service.getExpedienteSic(this.expedienteId, this.tipoDocumentoUsuario, this.numeroIdentificacion).subscribe({
      next: data => {
        this.expedienteData = data;
        // this.historicoSic = this.expedienteData.actuaciones!;
        this.historicoSic = this.expedienteData.actuaciones!.map(historico => ({
          ...historico,
          documento: 'Ver documentos',
        }));
        const estados = this.historicoSic.map(item => ({
          value: item.estado_proceso,
        }));
        this.estadoProceso = Array.from(new Set(estados));
        this.initColumns();
      },
      error: err => {
        console.error('Error getting data', err);
      },
    });
  }

  initColumns() {
    this.columns = [
      {
        field: 'numero_proceso',
        title: this.tableText['consecutivo'],
        type: 'number',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'numero_proceso'
      },
      {
        field: 'marca_tiempo',
        title: this.tableText['fecha'],
        type: 'date',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'marca_tiempo',
        pipe: 'dd/MM/yyyy HH:mm',
      },
      {
        field: 'estado_proceso',
        title: this.tableText['actuacion'],
        type: 'select',
        elements: this.estadoProceso,
        value: 'value',
        option: 'value',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'estado_proceso',
      },
      {
        field: 'usuario',
        title: this.tableText['solicitante'],
        type: 'text',
        filterable: true,
        sortable: true,
        fieldFilterElement: 'usuario',
      },
      {
        field: 'documento',
        title: this.tableText['ver'],
        type: 'text',
        filterable: false,
        sortable: false,
        accion: item => {
          this.openModal(item);
        },
      },
    ];
  }

  crearAvanceProcesal() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}`,
    ]);
  }

  navigateAvanceProcesalSolicitudes() {
    this.router.navigate([
      `expediente/${this.entidadId}/avance-procesal/${this.expedienteId}/solicitudes`,
    ]);
  }

  openModal(item: any) {
    const modalData: any = {
      ...item,
      entidadId: this.entidadId,
      expedienteId: this.expedienteId,
      nombreEntidad: Entidades.SIC,
      numeroProceso: item.numero_proceso,
    };
    this.modalService.openModal(DescargaDocumentosComponent, modalData);
  }

  // Función que ejecuta la guía intractiva en caso de ser el primer inicio de sesión
  iniciarGuiaInteractiva() {
    const driverObj = driver({
      showProgress: true,
      nextBtnText: 'Siguiente',
      prevBtnText: 'Anterior',
      doneBtnText: 'Finalizar',
      steps: [
        {
          element: '#tour',
          popover: {
            title: 'Guía interactiva para histórico del expediente de la SIC',
            description:
              'Este es un recorrido guiado interactivo que le permite conocer y familiarizarse con las opciones y funcionalidades que ofrece el sistema.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#navbarDropdownDetalle',
          popover: {
            title: 'Información de usuario',
            description:
              'El nombre e identificación del usuario que se encuentra conectado a la plataforma.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#dropdownAlertasButton',
          popover: {
            title: 'Alertas',
            description:
              'Muestra una bandeja con el número de modificaciones realizadas sobre el expediente desde la última vez que el usuario entró a este.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#glosario',
          popover: {
            title: 'Glosario jurídico',
            description:
              'Un glosario con conceptos y sus definiciones que le ayudarán a entender el estado de sus procesos.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#informacion',
          popover: {
            title: 'Información',
            description:
              'Este apartado presenta información relevante acerca de la información que se visualiza en la pantalla.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#encabezado',
          popover: {
            title: 'Encabezado',
            description:
              ' Aquí se encuentra la información más relevante del proceso, como el momento de creación y el número de expediente.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#filtro',
          popover: {
            title: 'Barra de búsqueda',
            description:
              'Este cuadro le permitirá buscar información específica dentro de su expediente.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#crearSolicitud',
          popover: {
            title: 'Creación de solicitud',
            description:
              'Esta opción le permite crear una solicitud a la entidad en materia de su expediente.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#historico',
          popover: {
            title: 'Histórico de solicitudes',
            description:
              'Una lista que contiene las solicitudes de avance procesal que ha realizado a lo largo del tiempo.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#marca_tiempo',
          popover: {
            title: 'Marca de tiempo',
            description:
              'El momento en el que se registró la actuación en el sistema.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#usuario',
          popover: {
            title: 'Usuario',
            description: 'El usuario que realizó la actuación.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#estado_proceso',
          popover: {
            title: 'Estado',
            description: 'El estado procesal.',
            side: 'bottom',
            align: 'start',
          },
        },
        {
          element: '#documento',
          popover: {
            title: 'Documento asociado',
            description:
              'Un enlace que lo dirigirá al documento sobre el cual se realizó un avance. Es posible descargar el archivo una vez se seleccione el documento.',
            side: 'bottom',
            align: 'start',
          },
        },
      ],
    });

    driverObj.drive();
  }
}
